<template>
    <div>
        <div v-if="modals" style="position: fixed;left: 0;right: 0;top: 0;bottom: 0;background: black;z-index: 9999;opacity: 0.8;"></div>
        <section class="section address_pop-up" v-if="modals === 'selectCity'">
            <i class="fas fa-times close" @click="hideModal()"></i>
            <div class="address_title">
                <div class="container">
                    <h2>Введите адрес доставки и мы покажем, где заказать быстрее и выгоднее всего</h2>
                </div>
            </div>
            <div class="container">
                <div class="address_box">
                    <div class="city">
                        <h2>{{auth.city}}</h2>
                        <span class="city_change_toggle" id="changeCityClick">сменить город</span>
                        <select class="city_input" id="city_change">
                          <option value=""></option>
                        </select>
                    </div>
                    <div class="address_form">
                        <input type="text" placeholder="Адрес" class="address" id="input_select_city" ref="address3" :value="geo.address">
                        <button type="submit" class="menu_item_btn" @click="updateRout">найти</button>
                    </div>
                </div>
            </div>
        </section>
        <div class="login-modal" v-if="modals === 'login'" id="login-modal">
            <section class="section main-pop_up">
                <i class="fas fa-times close" @click="hideModal()"></i>
                <div class="container">
                    <div class="form_box">
                        <div class="auth_form">
                            <input type="text" name="" class="auth" placeholder="Логин"  v-model="login">
                            <input type="password" name="" class="auth" placeholder="Пароль" v-model="password">
                            <button type="submit" class="menu_item_btn" @click="sendLogin">Войти</button>
                        </div>
                        <div class="reference">
                            <h4>Нет аккаунта?<a href="#" @click="modals = 'register'">Зарегистрируйся!</a></h4>
                            <h4>Забыли пароль?<a href="#" @click="modals = 'reset'">Восстановить доступ</a></h4>
                        </div>
                    </div>
                    <div class="advantages_box">
                        <div class="advantage">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/icon-cashback.svg" alt="">
                            <div class="advantage_description">
                                <h2>Реальный cash-back</h2>
                                <p>У нас нет непонятных бонусов с непонятной конвертацией.
                                    Всё просто! 1 бонусный рубль = 1 рубль</p>
                            </div>
                        </div>
                        <div class="advantage">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/icon-gift.svg" alt="">
                            <div class="advantage_description">
                                <h2>Скидки и подарки</h2>
                                <p>После регистрации Вы получаете скидки и подарки на День Рождения</p>
                            </div>
                        </div>
                        <div class="advantage">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/icon-team.svg" alt="">
                            <div class="advantage_description">
                                <h2>Реферальная программа</h2>
                                <p>Регистрируйтесь, приводите друзей и знакомых, получайте бонусные рубль</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="registration-modal" v-if="modals === 'register'" id="registration-modal">
            <section class="section main-pop_up">
                <i class="fas fa-times close" @click="hideModal()"></i>
                <div class="container">
                    <div class="form_box">
                        <div class="auth_form">
                            <input type="text" class="auth" name="email" v-model="email"  v-bind:placeholder="'E-mail'" />
                            <input type="tel" class="auth" name="phone" v-model="phone" data-inputmask="'mask': '+9(999)999-99-99'" v-bind:placeholder="'Телефон'">
                            <input type="password" class="auth" name="password" v-model="password" v-bind:placeholder="'Пароль'">
                            <input type="password" class="auth" v-model="password2" name="password_confirmation" v-bind:placeholder="'Повторите пароль'">
                            <input type="text" class="auth" v-model="promo" placeholder="Промокод (если есть)" />
                            <input type="checkbox" name="personal" class="input_reg" v-model="checkRules" required> <router-link to="/rules" target="_blank">Согласие на обработку персональных данных</router-link>
                            <p>⠀</p>
                            <button type="submit" class="menu_item_btn" @click="sendRegister">Зарегистрироваться</button>
                        </div>
                    </div>
                    <div class="advantages_box">
                        <div class="advantage">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/icon-cashback.svg" alt="">
                            <div class="advantage_description">
                                <h2>Реальный cash-back</h2>
                                <p>У нас нет непонятных бонусов с непонятной конвертацией.
                                    Всё просто! 1 бонусный рубль = 1 рубль</p>
                            </div>
                        </div>
                        <div class="advantage">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/icon-gift.svg" alt="">
                            <div class="advantage_description">
                                <h2>Скидки и подарки</h2>
                                <p>После регистрации Вы получаете скидки и подарки на День Рождения</p>
                            </div>
                        </div>
                        <div class="advantage">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/icon-team.svg" alt="">
                            <div class="advantage_description">
                                <h2>Реферальная программа</h2>
                                <p>Регистрируйтесь, приводите друзей и знакомых, получайте бонусные рубль</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="change-password-modal" v-if="modals === 'reset'" id="change-password-modal">
            <section class="section main-pop_up">
                <i class="fas fa-times close" @click="hideModal()"></i>
                <div class="container">
                    <div class="form_box">
                        <div class="auth_form">
                            <input type="text" v-show="useEmail" class="auth" v-model="email"  v-bind:placeholder="'E-mail'" />
                            <input type="tel" v-show="!useEmail" class="auth" v-model="phone" data-inputmask="'mask': '+9(999)999-99-99'" v-bind:placeholder="'Телефон'"/>
                            <span id="change-phone-error"></span>
                            <label class="index__checkbox index__label index__checkbox-use-email">
                                <input type="checkbox" name="use_email" class="checkbox" v-model="useEmail">
                                <span class="checkmark">
                                                <span class="index__after" v-show="useEmail"></span>
                                            </span>
                                <span class="label__text"> Использовать для авторизации E-mail</span>
                            </label>
                            <p></p>
                            <button type="submit" class="menu_item_btn" @click="sendReset">Восстановить</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="lk-popup bonus"  v-if="modals === 'sendMoney'">
            <div class="title">
                <h1>Перевести бонусы</h1>
                <i class="fas fa-times close" @click="data = 0, hideModal()"></i>
            </div>
            <div class="content_box">
                <div class="success_box" v-if="parseInt(user.money) === 0">
                    <h2>К сожалению у вас нет денег на счету =(</h2>
                </div>
                <div class="bonus_form" v-else-if="data === 0">
                    <div class="comment_box">
                        <span>Введите сумму</span>
                        <input type="number" v-model="money" min="0" :max="user.money" class="input">
                    </div>
                    <button class="menu_item_btn" @click="sendMoney">Перевести</button>
                </div>
                <div class="success_box" v-else-if="data === 1">
                    <h2>Запрос успешно отправлен!</h2>
                    <p>В ближайшее время мы переведем средства на ваш счет</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import 'select2/dist/css/select2.min.css'
import 'select2'
import axios from '@/router/http'
import Inputmask from 'inputmask'
export default {
  name: 'modals',
  props: ['city', 'mapinit', 'geo', 'modals', 'auth', 'user', 'messages', 'modalsdata'],
  data () {
    return {
      geocoder: null,
      autocomplete: [],
      useEmail: 0,
      login: null,
      password: null,
      email: null,
      phone: null,
      password2: null,
      promo: null,
      checkRules: null,
      html: null,
      pageName: null,
      money: null,
      data: 0
    }
  },
  watch: {
    modalsdata (val) {
      axios.get('https://lk.when-hungry.com/mobile/get-page?link=' + val).then(response => {
        if (!response.data.error) {
          this.pageName = response.data.name
          this.html = response.data.html
        } else {
          this.pageName = null
          this.html = null
        }
      })
    },
    modals (val) {
      setTimeout(() => { this.sModal(val) }, 400)
      Inputmask().remove(document.getElementById('input'))
      setTimeout(() => { Inputmask().mask(document.querySelectorAll('input')) }, 500)
    },
    'auth.city' (val) {
      if (this.modals === 'selectCity') {
        this.geocoder = new google.maps.Geocoder()
        this.geocoder.geocode({'address': this.city.name, 'language': 'ru'}, (results, status) => {
          if (status === 'OK') {
            this.autocomplete[0] = new google.maps.places.Autocomplete(this.$refs.address3, {bounds: results[0].geometry.bounds, 'language': 'ru'})
            this.autocomplete[0].addListener('place_changed', () => {
              this.changePlace(this.autocomplete[0].getPlace(), $('#input_select_city').val())
            })
          }
        })
      }
    }
  },
  methods: {
    sendMoney () {
      if (!this.money) alert('Вам необходимо указать сумму вывода')
      else if (parseInt(this.money) > parseInt(this.user.money)) alert('Увы у вас нет столько средств на счету')
      else if (parseInt(this.money) <= 0) alert('Мы вас столько не можем вывести :)')
      else if (!this.user.pay || !this.user.payType) alert('Вам необходимо указать данные для вывода средств в разделе "Мои данные"')
      else {
        var formData = new FormData()
        formData.append('money', this.money)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/send-money',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.data = 1
        })
      }
    },
    alert (mes) {
      alert(mes)
    },
    sendReset () {
      if (!this.useEmail && !this.phone) alert('Вам необходимо заполнить телефон')
      else if (this.useEmail && !this.email) alert('Вам необходимо заполнить email')
      else {
        var formData = new FormData()
        if (this.useEmail) formData.append('email', this.email)
        else formData.append('phone', this.phone)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/reset-mobile-app',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          alert(response.data.text)
        })
      }
    },
    sendRegister () {
      if (!this.email && !this.phone) alert('Вам необходимо заполнить email или телефон')
      else if (!this.password) alert('Вы не ввели пароль')
      else if (this.password !== this.password2) alert('Введенные пароли не совпадают')
      else if (!this.checkRules) alert('Вам необходимо принять согласие на обработку персональных данных')
      else {
        var formData = new FormData()
        formData.append('email', this.email)
        formData.append('phone', this.phone)
        formData.append('password', this.password)
        formData.append('promo', this.promo)
        formData.append('bonus', '200')
        formData.append('city', this.city.id)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/reg-mobile-app',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          if (response.data.title === 'Ошибка') alert(response.data.text)
          else {
            this.auth = response.data
            window.location.href = '/cabinet'
          }
        })
      }
    },
    sendLogin () {
      var formData = new FormData()
      formData.append('login', this.login)
      formData.append('password', this.password)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/auth-mobile-app',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        if (response.data.title === 'Ошибка') alert(response.data.text)
        else {
          window.location.href = '/cabinet'
        }
      })
    },
    sModal (val) {
      // let self = this
      if (val === 'selectCity') {
        $('#map_city').select2({
          allowClear: false
        })
        $('#city_change').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/site/search-city',
            data: (params) => {
              params.id = this.city.country_id
              params.q = params.term
              params.all = 0
              params.country = 1
              params.comm = 1
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:open', function () {
          let select2 = $('#city_change')
          select2.data('select2').$dropdown.addClass('city_change_box')
          console.log($(select2).data('select2'))
          $(this).data('select2').$dropdown.addClass('city_change_box')
        })
        $('#changeCityClick').on('click', () => {
          let self = this
          $('#city_change').select2('open').on('select2:select', function () {
            self.geo.city = $(this).select2('data')[0].text
            self.geocoder.geocode({'address': $(this).select2('data')[0].text}, function (results, status) {
              if (status === 'OK') {
                self.autocomplete[0].setBounds(results[0].geometry.bounds)
              }
            })
            self.city.name = $(this).select2('data')[0].text
            self.city.id = $(this).val()
            self.geo.address = null
            self.geo.lat = null
            self.geo.city = $(this).select2('data')[0].text
            self.geo.lng = null
          })
        })
        this.geocoder = new google.maps.Geocoder()
        this.geocoder.geocode({'address': this.city.name, 'language': 'ru'}, (results, status) => {
          if (status === 'OK') {
            this.autocomplete[0] = new google.maps.places.Autocomplete(this.$refs.address3, {bounds: results[0].geometry.bounds, 'language': 'ru'})
            this.autocomplete[0].addListener('place_changed', () => {
              this.changePlace(this.autocomplete[0].getPlace(), $('#input_select_city').val())
            })
          }
        })
      }
    },
    changePlace (place, value) {
      var city
      var i
      for (i = 0; i < place.address_components.length; i++) {
        if (place.address_components[i].types[0] === 'locality') city = place.address_components[i]['long_name']
      }
      if (city === 'Київ') city = 'Киев'
      if (city === 'Днипро') city = 'Днепр'
      if (city === 'Дніпро́') city = 'Днепр'
      if (city === 'Одеса' || city === undefined || city === '') {
        for (i = 0; i < place.address_components.length; i++) {
          if (place.address_components[i].types[0] === 'political' || place.address_components[i].types[0] === 'administrative_area_level_1') city = place.address_components[i]['long_name']
        }
      }
      this.geo.address = value
      this.geo.lat = place.geometry.location.lat()
      this.geo.lng = place.geometry.location.lng()
      this.geo.city = city
    },
    hideModal () {
      this.$root.modals = null
    },
    hideModals () {
      this.$root.hideModal()
    },
    updateRout () {
      var formData = new FormData()
      formData.append('lat', this.geo.lat)
      formData.append('lng', this.geo.lng)
      formData.append('address', this.geo.address)
      formData.append('country', this.auth.country)
      formData.append('city', this.geo.city)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/put-mobile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.auth = response.data
        this.$root.user = response.data.users
        this.$root.geo.lat2 = this.geo.lat
        this.$root.geo.lng2 = this.geo.lng
        this.$root.modals = null
      })
    }
  }
}
</script>

<style scoped>
#login-modal, #registration-modal, #change-password-modal {
    position: fixed;left: 0;right: 0;margin: auto;z-index: 9999;padding: 0;top: 50%;transform: translateY(-50%);
}
.address_pop-up {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 9999;
}
.close {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 30px;
    opacity: 0.8;
    cursor: pointer;
    z-index: 9999;
}
.close:hover {
    opacity: 0.4;
}
.section.address_pop-up .container .address_box .city {
    margin-bottom: 0;
}
</style>
<style>
    .section.address_pop-up .container .address_box .city .select2.select2-container {
        visibility: hidden;
        height: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals.vue